module.exports = __webpack_public_path__ + "static/P1-Bellerive-ea28fe68d49cc95c957ef4e7c88a3bc6.jpeg";